import { Injectable } from '@angular/core';
import { CommonConstants } from 'src/app/shared/constant';
import { BearerToken } from './../models/bearer.token';
import { EncryptionService } from './encryption.service';
import { ClientService } from './client.service';

@Injectable()
export class TokenService {
  constructor(
    private readonly encryptionService: EncryptionService,
    private readonly clientService: ClientService
  ) {}
  private tokenKey: any = CommonConstants.authorizationKey;

  public setToken(token: BearerToken, isLongTerm: boolean): void {
    isLongTerm = true;
    let client = this.clientService.getClient();
    this.tokenKey = client.restaurantId;
    //const json = JSON.stringify(token);
    const json = this.encryptionService.setJson(token);

    if (isLongTerm) {
      localStorage.setItem(this.tokenKey, json);
    } else {
      sessionStorage.setItem(this.tokenKey, json);
    }
  }

  public getToken(): BearerToken {
    let client = this.clientService.getClient();
    if (!client?.restaurantId) {
      return null;
    }
    this.tokenKey = client.restaurantId;

    let storedToken: any = localStorage.getItem(this.tokenKey);

    if (storedToken == null) {
      storedToken = sessionStorage.getItem(this.tokenKey);
    }

    if (storedToken == null) {
      return null;
    }

    //const json: any = JSON.parse(storedToken);
    const json = this.encryptionService.getJson(storedToken);
    const token: BearerToken = new BearerToken(json);

    if (token.isExpired()) {
      this.removeToken();
      return null;
    } else {
      return token;
    }
  }

  public removeToken(): void {
    let client = this.clientService.getClient();
    this.tokenKey = client.restaurantId;

    localStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.tokenKey);
  }
}
